<!--
do not delete this file, we want preexisting
links to /browse/ to redirect to /documents/
-->
<script setup>
import { useMainStore } from '@/stores/mainStore';

definePageMeta({
  middleware: [
    function (to) {
      const mainStore = useMainStore();
      return navigateTo(`${mainStore.pathPrefix}/documents/${to.params.id}`);
    },
  ],
});
</script>
